const ROUTES_PATH = {
  inquiryContact: '/contact',
  inquiryConfirm: '/confirm',
  inquiryDone: '/done',
} as const;

export { ROUTES_PATH };
